// plugins
export const PLUGIN_REMOVE_LOGO_ENABLED = 'PLUGIN_REMOVE_LOGO_ENABLED';
export const PLUGIN_MANAGEMENT_ENABLED = 'PLUGIN_MANAGEMENT_ENABLED';
export const PLUGIN_STYLES_EDITING_ENABLED = 'PLUGIN_STYLES_EDITING_ENABLED';



// WEBPACK FOOTER //
// ./src/constants/feature-keys.js